import { type ClientQueries, defClientQueries } from '@kizen/query/client';
import AxiosService from '__services/AxiosService';

const queries: ClientQueries = defClientQueries(AxiosService);

export const allClientFieldsQuery: ClientQueries['allClientFieldsQuery'] =
  queries.allClientFieldsQuery;

export const clientCategoriesQuery: ClientQueries['clientCategoriesQuery'] =
  queries.clientCategoriesQuery;

export const clientFieldsQuery: ClientQueries['clientFieldsQuery'] =
  queries.clientFieldsQuery;
